import type { Visit } from '.';

import { gemsReward } from './visit.ruleset';

export const visitModifiers = (state: Visit.MutableState) => ({
  /**
   * Increment amount of gems received by player
   * @param friendId the friend visiting the player
   * @param now the current time
   */
  incrementGemsGrants(friendId: string, now: number) {
    const { visits, visitSession } = state.visit;
    const currentCount = visits[friendId]?.lastGemsGrantAt ?? 0;

    visitSession.gemsReceived += gemsReward;
    state.visit.gemsGrantsToday++;
    state.visit.lastGemsGrantAt = now;
    visits[friendId] = {
      count: visits[friendId]?.count ?? 0,
      lastUpdatedAt: now,
      lastGemsGrantAt: now,
    };
  },
});
